var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEveryone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "url(#pattern0_1224_1371)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1224_1371",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1224_1371",
    transform: "scale(0.0625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1224_1371",
    width: 16,
    height: 16,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAZhJREFUOE+Nkz3LgVEYx/93kvARKAMTNulZpJQSm5UNWSxYkCwsLCxYlM3iO5CSPAaKhWS5fQCzDM7TucrhuL08p+7hvl5+53+uF4Ux9gvgB2/O6XTCZrPBcDhEPp+Hw+F4jFwojDH2nHs4HDCfz1GpVKCqqnD3ej2kUikpnACXywXr9Rqj0QilUumdGLI/36eoqspsNtvHJO4MhUJIJBKIRqPQ6/UinhQoivISUC6XKdHj8cBkMgkFj/EE6Ha7yGQyGshN7m63w3Q6RTqdxng8RiAQkBVst1s4nU4NIB6PYzAYSPZsNotWqyUD+N+7Z7x62/l8hsFgIJdoY71e/9qBWq2GYDAIr9cLnU4nA1arFRXr+VSrVcRiMdjtduHa7/cwm82wWCx3BdfrVVAfIe12mwq8XC5pTgqFArmbzSZyudwdwI3FYhGNRuPrTNwCeJekUZ7NZvD5fP8GHI9HGcCrazQaPwI6nQ78fj9cLhd1TrNMyWQS/X5fQCKRCC0Qr7zVatXAOUBa58lkAv6Fw2G43W6q9oez+ANqZsIMYvLi9gAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEveryone);
export default __webpack_public_path__ + "static/media/everyone.b0f916fb62d06e28c14850b0c57b697c.svg";
export { ForwardRef as ReactComponent };